/**
 * Days the Auth0 SDK keeps its "this browser had a session" cookie.
 *
 * The SDK checks that cookie before it will read the token it already holds in
 * local storage, so this value, not the token lifetime, decides how long
 * somebody stays signed in across visits. The SDK default is one day.
 *
 * It cannot usefully exceed the tenant's own SSO session lifetime: past that
 * the silent renewal fails regardless, and a failed renewal clears the stored
 * session. Raise Login Session Management in the Auth0 dashboard to match.
 */
export const AUTH0_SESSION_CHECK_EXPIRY_DAYS = 30;
